import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { OrganisatieIcon } from "../../atoms/icons/OrganisatieIcon";
import { useTranslation } from 'react-i18next';


// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<string>;
export const Organisatie = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tDatatypes } = useTranslation('datatypes');
    
    const label = props.label || tDatatypes('organisatieLabel') ||"Organisatie";
    return (<Caption {...props} caption={label} icon={<OrganisatieIcon />}>
        {props.value}
    </Caption>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));